import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  employer: {},
  jobs: [],
  categories: [],
  employers: [],
  report: ''
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/employer/vuex/index.js